import { Select } from 'antd';
import { useUnit } from 'effector-react';
import style from './RegionsTree.module.css';
import {
  $regionsLayer,
  changeRegionsLayerEv,
} from '../../models/investProModel/index.js';
import { layers_dictionary } from '../../dictionaries/layers_dictionary.js';

const options = Object.keys(layers_dictionary).map((item) => {
  return {
    label: layers_dictionary[item],
    value: item,
  };
});

function RegionsLayerSelector() {
  const regionsLayer = useUnit($regionsLayer);
  const changeRegionsLayer = useUnit(changeRegionsLayerEv);

  return (
    <Select
      className={style.regions_layer_selector}
      value={regionsLayer}
      options={options}
      onChange={changeRegionsLayer}
    />
  );
}

export default RegionsLayerSelector;
